import React from 'react';
import classNames from 'classnames';
import { useFormContext } from 'react-hook-form';

import FormError from '../FormError';

interface IFormLabel {
  field: string,
  name?: string,
  className?: string,
  children: React.ReactNode,
  errorDefaultValue?: string,
}

const FormLabel = ({
  field,
  name,
  className = '',
  children,
  errorDefaultValue = 'This field contains errors',
}: IFormLabel) => {
  const { formState: { errors } } = useFormContext();

  name = name ?? field.split('_').map((f) => f.charAt(0)
    .toUpperCase() + f.slice(1))
    .join(' ');

  return (
    <label htmlFor={field} className={classNames({
      [className]: true,
      error: errors[field],
    })} >
      <p>{name}</p>
      {children}
      <FormError
        field={errors[field]}
        defaultValue={errorDefaultValue} />
    </label>
  );
};

export default FormLabel;
